import config from './config';
import api    from './api';

export default api(config);
